import { SecurityRuleFactory, createSimpleClaimRule } from "../auth-rules";

export type IsAdminClaimType = string | string[];
export type IsAdminClaimArgs = {};

export const ruleIsAdmin: SecurityRuleFactory<IsAdminClaimType, IsAdminClaimArgs> =
  createSimpleClaimRule<IsAdminClaimType, IsAdminClaimArgs>("admin");

